export default "__VITE_ASSET__qM6IVpZZ__"